import { REACT_APP_API_ENDPOINT } from "../helpers/data";
import { handleResponse, sendGetRequest, sendPostRequest, sendPutRequest } from "./apiUtilis";

export const addNewUser = async (req) => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "user", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        return error;  // Re-throw the error after logging it
    }
};

export const getUserProfile = async () => {
  try {
    const response = await sendGetRequest(REACT_APP_API_ENDPOINT + "user");
    console.error("Response:", response);
    return handleResponse(response);
  } catch (error) {
    console.error("Error in getUserProfile:", error);
    throw error; // Re-throw the error after logging it
  }
};

export const editUserProfile = async (req) => {
  try {
    const response = await sendPutRequest(REACT_APP_API_ENDPOINT + "user", req);
    console.error("Response:", response);
    return handleResponse(response);
  } catch (error) {
    console.error("Error in editUserProfile:", error);
    throw error; // Re-throw the error after logging it
  }
};
